import {createAction, props} from '@ngrx/store';

export const metaDataResetAction = createAction(
  '[Meta] Registered Tags Reset',
  props<{mergedParams: any; mergedData: any; url: string}>()
);

export const overviewDataProcessedAction = createAction('[Meta] OverviewData Processed', props<any>());
export const articleDataProcessedAction = createAction('[Meta] ArticleData Processed', props<any>());
